// extracted by mini-css-extract-plugin
export default {"widgetContainer":"widgetContainer_KmR1","widgets":"widgets_HGRT"};